import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from "prop-types";
import withRouter from '../Components/Common/withRouter';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import RightSidebar from '../Components/Common/RightSidebar';
import '@fortawesome/fontawesome-free/css/all.min.css';
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility,
    changePreLoader
} from "../slices/thunks";

import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import ApiService from "../admin/components/util/ApiService";
import LoadingScreen from "../admin/components/util/LoadingScreen";

const Layout = (props) => {
    const [loadingLayout, setLoadingLayout] = useState(true);

    const dispatch = useDispatch();

    const selectLayoutState = (state) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        layout => ({ ...layout })
    );

    const layoutSettings = useSelector(selectLayoutProperties);

    const onChangeLayout = useCallback((data) => {
        if (!data) return;

        dispatch(changeLayout(data.layoutType));
        dispatch(changeSidebarTheme(data.leftSidebarType));
        dispatch(changeLayoutMode(data.layoutModeType));
        dispatch(changeLayoutWidth(data.layoutWidthType));
        dispatch(changeLayoutPosition(data.layoutPositionType));
        dispatch(changeTopbarTheme(data.topbarThemeType));
        dispatch(changeLeftsidebarSizeType(data.leftsidbarSizeType));
        dispatch(changeLeftsidebarViewType(data.leftSidebarViewType));
        dispatch(changeSidebarImageType(data.leftSidebarImageType));
        dispatch(changePreLoader(data.preloader));
        dispatch(changeSidebarVisibility(data.sidebarVisibilitytype));
    }, [dispatch]);

    useEffect(() => {
        const carregarConfiguracoesSalvas = async () => {
            try {
                const cache = localStorage.getItem('layout');
                let config = null;

                if (cache) {
                    try {
                        config = JSON.parse(cache);
                        onChangeLayout(config);
                    } catch (e) {
                        localStorage.removeItem('layout');
                    }
                }

                const response = await ApiService.send('get', `${process.env.REACT_APP_URL_API}custom-domain/config/layout`, {}, true);
                const { data } = ApiService.handleApiResponse(response);

                if (JSON.stringify(config) !== JSON.stringify(data)) {
                    localStorage.setItem('layout', JSON.stringify(data));
                    onChangeLayout(data);
                }
            } catch (error) {
                console.error('Erro ao carregar configurações do layout:', error);
            } finally {
                setLoadingLayout(false); // encerra o loading sempre
            }
        };

        const domain = window.location.hostname;

        const carregarCustomizacoes = async () => {
            try {
                const response = await ApiService.send('get', `${process.env.REACT_APP_URL_API}custom-domain/get-css`, {}, true);
                const data = response?.data || response;

                if (!data) return;

                // Aplicar CSS customizado
                if (data.css) {
                    const styleElementoAnterior = document.getElementById('custom-domain-css');
                    if (styleElementoAnterior) {
                        styleElementoAnterior.remove();
                    }

                    const styleElement = document.createElement('style');
                    styleElement.id = 'custom-domain-css';
                    styleElement.innerHTML = data.css;
                    document.head.appendChild(styleElement);
                }

                // Armazenar imagens no localStorage
                const imagens = {
                    logo: data.logo,
                    logoWhite: data.logoWhite,
                    smallLogo: data.smallLogo,
                    favicon: data.favicon,
                    loadingIcon: data.loadingIcon,
                    title: data.title,
                    titleFooter: data.titleFooter,
                    companyUrlFooter: data.companyUrlFooter,
                    logoLoginWidth: data.logoLoginWidth,
                    logoSidebarWidth: data.logoSidebarWidth,
                    logoSidebarSmWidth: data.logoSidebarSmWidth,
                };
                localStorage.setItem(`custom_images_${domain}`, JSON.stringify(imagens));

                // Atualizar favicon
                if (data.favicon) {
                    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = data.favicon;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }

                // Atualizar título
                if (data.title) {
                    document.title = data.title;
                }

            } catch (error) {
                console.error('Erro ao carregar customizações:', error);
            }
        };

        carregarConfiguracoesSalvas();
        carregarCustomizacoes();
    }, [onChangeLayout]);


    const [headerClass, setHeaderClass] = useState("");

    useEffect(() => {
        const scrollNavigation = () => {
            const scrollup = document.documentElement.scrollTop;
            setHeaderClass(scrollup > 50 ? "topbar-shadow" : "");
        };

        window.addEventListener("scroll", scrollNavigation);
        return () => window.removeEventListener("scroll", scrollNavigation);
    }, []);

    useEffect(() => {
        const icon = document.querySelector(".hamburger-icon");
        if (!icon) return;

        if (layoutSettings.sidebarVisibilitytype === 'show' || layoutSettings.layoutType === "vertical" || layoutSettings.layoutType === "twocolumn") {
            icon.classList.remove('open');
        } else {
            icon.classList.add('open');
        }
    }, [layoutSettings.sidebarVisibilitytype, layoutSettings.layoutType]);

    return (
        <>
            {loadingLayout ? (
                <LoadingScreen />
            ) : (
                <React.Fragment>
                    <div id="layout-wrapper">
                        <Header
                            headerClass={headerClass}
                            layoutModeType={layoutSettings.layoutModeType}
                            onChangeLayoutMode={(mode) => dispatch(changeLayoutMode(mode))}
                        />
                        <Sidebar layoutType={layoutSettings.layoutType} />
                        <div className="main-content">
                            {props.children}
                            <Footer />
                        </div>
                    </div>
                    <RightSidebar />
                </React.Fragment>
            )}
        </>
    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(Layout);
